import { ClinicalActivitiesPreferenceDto } from "@libs/gateways/clinical/ClinicalGateway.dtos.ts";
import { Model } from "@libs/models/Model.ts";

export class ClinicalActivitiesPreference extends Model<ClinicalActivitiesPreferenceDto> {
  get allowReminderFreeText() {
    return this.dto.allowReminderFreeText;
  }

  get useReminderMinRange() {
    return this.dto.useReminderMinRange;
  }

  get reminderMinWeekRange() {
    return this.dto.reminderMinWeekRange;
  }
}
